import _regeneratorRuntime from "@babel/runtime/regenerator";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";

/** @jsx $jsx */
import { $jsx } from 'framework7';
import $ from 'dom7';
import Base from '../js/base.js';
import Utils from '../js/utils.js';
import moment from 'moment';
var Faq = {
  pn: 'div[data-name=faq]',
  page: 0,
  limit: 20,
  currentDisplay: 0,
  allowInfinite: true,
  hasMoreItems: true,
  totalItems: 0,
  filter: {},
  init: function init() {
    var _this = this;

    var self = this;
    self.page = 0;
    self.currentDisplay = 0;
    self.allowInfinite = true;
    self.hasMoreItems = true;
    Base.faqItems = new Map();
    self.list();
    $(self.pn + ' .infinite-scroll-content').on('infinite', function () {
      if (!self.allowInfinite) return;
      self.allowInfinite = false;
      self.page += 1;
      self.list();
    });
    $('input[type="search"]').keyup(function (e) {
      return _this.search(e);
    });
    $('.clear-search').click(function (e) {
      _this.page = 0;
      _this.filter = {};
      $(_this.pn + ' .faq-list').html('');

      _this.list();
    });
  },
  search: function search(e) {
    if (e.which !== 13) return false;
    var s = $(e.target).val();
    if (s === '') return false;
    this.page = 0;
    this.filter = {
      s: s
    };
    $(this.pn + ' .faq-list').html('');
    this.list();
  },
  list: function () {
    var _list = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var self, rs;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              self = this;
              _context.next = 3;
              return Base.api('Faq', 'list', {
                page: this.page,
                limit: this.limit,
                filter: this.filter
              });

            case 3:
              rs = _context.sent;
              self.totalItems = rs.total;

              if (!(rs.rows.length == 0)) {
                _context.next = 8;
                break;
              }

              $(self.pn + ' .infinite-scroll-preloader').addClass('display-none');
              return _context.abrupt("return");

            case 8:
              self.currentDisplay += rs.rows.length;
              self.allowInfinite = true;
              rs.rows.forEach(function (item, i) {
                $(self.pn + ' .faq-list').append(self.row(item));
                Base.faqItems.set(item.id, item);
              });
              if (self.currentDisplay == self.totalItems || self.currentDisplay > self.totalItems) $(self.pn + ' .infinite-scroll-preloader').addClass('display-none');else $(self.pn + ' .infinite-scroll-preloader').removeClass('display-none');

            case 12:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, this);
    }));

    function list() {
      return _list.apply(this, arguments);
    }

    return list;
  }(),
  row: function row(item) {
    var name = Utils.str2Num(item.show_name) === 0 ? Base.anonymousLabel : item.name;
    var tags = item.tags;
    var htmlTags = '';

    if (tags != null && tags !== '') {
      tags = tags.split(',');
      var tagArr = [];
      tags.forEach(function (tag) {
        tagArr.push("<div class=\"chip chip-outline\"><div class=\"chip-label\">".concat(tag, "</div></div>"));
      });
      htmlTags = tagArr.join('');
    }

    var replies = Utils.str2Num(item.total_answers);
    if (replies === 0) replies = "<span style=\"color:red\">".concat(replies, "</span>");
    var $row = $("\n      <li>\n        <a href=\"/faq-answer-popup/".concat(item.id, "\" class=\"item-link item-content\">\n          <div class=\"item-inner\">\n            <div class=\"item-subtitle\">").concat(htmlTags, "</div>\n            <div class=\"item-text text-color-white\">").concat(item.content, "</div>\n            <div class=\"item-title-row\" style=\"font-size: 10px;\">\n              <div class=\"item-title\">").concat(name, " | Tr\u1EA3 l\u1EDDi: ").concat(replies, "</div>\n              <div class=\"item-after\">").concat(moment(item.created_date).format(Base.dateTimeFormat), "</div>\n            </div>\n          </div>\n        </a>\n      </li>"));
    return $row;
  }
};
export default (function ($prop, ctx) {
  ctx.$on('pageInit', function () {
    Faq.init();
    Base.app.off('questionCreated');
    Base.app.on('questionCreated', function (item) {
      $(Faq.pn + ' .faq-list').prepend(Faq.row(item));
      Base.faqItems.set(item.id, item);
    });
  });

  var profile = function profile() {
    Base.profile();
  };

  return function ($ctx) {
      var $ = $ctx.$;
      var $h = $ctx.$h;
      var $root = $ctx.$root;
      var $f7 = $ctx.$f7;
      var $f7route = $ctx.$f7route;
      var $f7router = $ctx.$f7router;
      var $theme = $ctx.$theme;
      var $update = $ctx.$update;
      var $store = $ctx.$store;

      return $h`
  <div class="page" data-name="faq">
    <div class="navbar">
      <div class="navbar-bg"></div>
      <div class="navbar-inner">
        <div class="left"></div>
        <div class="title sliding">Hỏi / Đáp</div>
        <div class="right"><a href="#" @click=${profile}><i class="f7-icons icon">person_circle</i></a></div>
      </div>
    </div>
    <div class="toolbar toolbar-bottom">
      <div class="toolbar-inner">
        <a href="/faq-question-popup/" class="button">Thêm câu hỏi</a>
      </div>
    </div>
    <div class="searchbar">
      <div class="searchbar-inner">
        <div class="searchbar-input-wrap">
          <input type="search" placeholder="Tìm theo thẻ hoặc từ khoá" />
          <i class="searchbar-icon"></i>
          <span class="input-clear-button clear-search"></span>
        </div>
      </div>
    </div>
    <div class="page-content infinite-scroll-content infinite-scroll-bottom">
      <div class="searchbar-backdrop"></div>
      <div class="list media-list no-margin">
        <ul class="faq-list">

        </ul>
        <div class="preloader infinite-scroll-preloader"></div>
      </div>
    </div>
  </div>
`
    }
    ;
});